import { VeltComments, VeltCommentsSidebar, VeltProvider } from '@veltdev/react';
import './App.css';
import Dashboard from './components/Dashboard';
import Header from './components/Header';

function App() {

  const sidebarCommentClickCallback = (data: any) => {
    console.log('sidebarCommentClickCallback', data);
  }

  return (
    <VeltProvider apiKey='Futi5jkMRdrobOrQvL8U'>
      <div>
        <Header />
        <VeltComments popoverMode={true} dialogOnHover={false} dialogOnTargetElementClick={false} />
        <VeltCommentsSidebar onSidebarCommentClick={(data: any) => sidebarCommentClickCallback(data)} />
        <Dashboard />
      </div>
    </VeltProvider>
  );
}

export default App;
